<script setup>
const props = defineProps({
  count: { type: Number, default: 0 },
});

const formattedCount = value => (value > 99 ? '99+' : value);
</script>

<template>
  <span
    v-if="props.count > 0"
    class="inline-flex shrink-0 h-5 min-w-5 items-center justify-center rounded-full border-2 border-white bg-[#15803D] px-1 text-[11px] font-bold leading-none text-white"
    aria-hidden="true"
  >
    {{ formattedCount(props.count) }}
  </span>
</template>
